import { render, staticRenderFns } from "./ContasReceberList.vue?vue&type=template&id=55ecc204&scoped=true"
import script from "./ContasReceberList.vue?vue&type=script&lang=js"
export * from "./ContasReceberList.vue?vue&type=script&lang=js"
import style0 from "./ContasReceberList.vue?vue&type=style&index=0&id=55ecc204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ecc204",
  null
  
)

export default component.exports